<template>
  <mw-dialog ref="dialog" size="small_large" :title="title" :appendToBody="false" :footerButton="footerButton"  customClass="mw-flow-complete"  :beforeClose="beforeClose">
    <el-form :model="form" label-width="100px" :rules="formRules" ref="virtuallogForm" style="padding-top:20px;">
      <el-row >
        <el-col :span="24">
          <el-form-item :label="$lang('代录节点')+'：'">
            <el-select v-model="form.agentRecordActId" @change="changeAgentRecordAct">
              <el-option
                v-for="item in agentRecordActs"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="height:325px; padding-top:5px;">
        <el-col :span="12" class="__col-h100">
            <div class="__panel __tree-panel">
              <div class="__panel-heading">{{$lang('可选领导')}}：<span class="pull-right"
                                                                                style="padding-right:5px;">({{$lang('双击移入')}}>>)</span>
              </div>
              <div class="__panel-body">
                <mw-li-tree :autoLoad="true" :async="false" :multiple="false"
                            ref="candidate" :treeData="currentCandidates" @dblClick="dblClick"  @beforeDataFilter="candidateDataHandle"></mw-li-tree>
              </div>
            </div>
        </el-col>
        <el-col :span="12" class="__col-h100" style="padding-left:5px;">
          <div class="__panel __tree-panel">
            <div class="__panel-heading">{{$lang('已选领导')}}：<span class="pull-right" style="padding-right:5px;">({{$lang('双击移出')}})</span></div>
            <div class="__panel-body">
              <mw-li-tree :autoLoad="true" :async="false" :multiple="true"
                          ref="planned" :treeData="currentPlannedes" @dblClick="dblClickSelected"></mw-li-tree>
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row style="padding-top:10px;">
        <el-col :span="24">
          <el-form-item :label="$lang('办理意见')+'：'" prop="comment">
            <el-input type="textarea" v-model="form.comment"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </mw-dialog>
</template>
<script>
  import virtuallog from "./virtuallog";
  export default virtuallog
</script>





// WEBPACK FOOTER //
// src/common/components/public-dialog/virtuallog.vue